/**
 * This is the place to encapsulate any common requirements for
 * all cohorts (ie. control & variations).
 *
 * Returns a Promise. If it meets the requirements of this experiment,
 * resolve it, otherwise reject with the WithdrawExperimentException.
 * meets the requirements for this experiment.
 */

import WithdrawExperimentException from "common-core/withdraw-experiment-exception";

// Change this to true if you need JQuery
const JQUERY_REQUIRED = true;

module.exports = function() {
    return (JQUERY_REQUIRED
        ? require("common/core-requirements/jquery-requirement").check()
        : Promise.resolve()
    ).then(() => {
        // TODO: Introduce conditions appropriate to your experiment.
        if (/.*/.test(window.location.pathname)) {
            return true;
        } else {
            throw new WithdrawExperimentException();
        }
    });
};



// WEBPACK FOOTER //
// ./src/common/should-run.js